// Angular
import { RouterModule, Routes } from "@angular/router";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

import { MenuDesignerComponent } from "./menu-designer.component";
import { MainMenuDesignerComponent } from "./main-menu-designer.component";
import { FooterMenuDesignerComponent } from "./footer-menu-designer.component";
import { MainMenuItemEditComponent } from "./main-menu-item-edit.component";

// BBWT
import { GridModule } from "@features/grid";
import { BbIconDropdownModule } from "@features/bb-icon-dropdown/bb-icon-dropdown.module";
import { BbCardModule } from "@features/bb-card";
import { BbTooltipModule } from "@features/bb-tooltip";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { AccessDirectivesModule } from "@main/access-directives/access-directives.module";
import { OfflineModule } from "@main/offline/offline.module";
import { DatabaseItemsComponent } from "./database-items.component";
import { SelectParentDialogComponent } from "./select-parent-dialog.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";

const routes = <Routes>[
    {
        path: "",
        component: MenuDesignerComponent,
        data: { title: "Menu Designer" }
    },
    {
        path: "database-items",
        component: DatabaseItemsComponent,
        data: { title: "Database Menu Items" }
    }
];

@NgModule({
    declarations: [
        MenuDesignerComponent,
        MainMenuDesignerComponent,
        MainMenuItemEditComponent,
        FooterMenuDesignerComponent,
        DatabaseItemsComponent,
        SelectParentDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimeNgModule,
        GridModule,
        BbIconDropdownModule,
        BbCardModule,
        BbTooltipModule,
        AccessDirectivesModule,
        BbwtSharedModule,
        OfflineModule,
        RouterModule.forChild(routes),
        MiproSharedModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MenuDesignerModule {}
